<!-- 竞猜规则弹窗 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="title-text">游戏币领取规则</div>
        <div class="tag"><img :src="require('../assets/happy.png')" alt="" height="65"></div>
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" alt="" height="33"></div>
        <div class="rule-cont">
            <div class="rule-item">
                <div class="cont">1、</div>
                <div class="flex-cont">
                    <div class="txt">用户仅可通过点击赞助商免费获得游戏币，抢到的游戏币用于参与足球竞猜活动； </div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">2、</div>
                <div class="flex-cont">
                    <div class="txt">赞助商家每天免费发放游戏币，每个赞助商每天发放的游戏币数量有限，先抢先得，发完为止；</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">3、</div>
                <div class="flex-cont">
                    <div class="txt">用户通过点击赞助商，获得随机数量游戏币，具体以实际领取为准；</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">4、</div>
                <div class="flex-cont">
                    <div class="txt">用户每天可以领取多个赞助商家发放的游戏币，对同一个商家每天只能领取一次游戏币；</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">5、</div>
                <div class="flex-cont">
                    <div class="txt">用户领取游戏币后，可在活动页面上方“我的游戏币”-"查看明细"，查看具体领取的游戏币数量及相关明细；</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">6、</div>
                <div class="flex-cont">
                    <div class="txt">不支持用户之间进行游戏币的转让；</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">7、</div>
                <div class="flex-cont">
                    <div class="txt">活动期间，如用户出线违规行为（包括但不限于机器作弊等），我们将取消违规获得的游戏币，必要时追求法律责任。</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">8、</div>
                <div class="flex-cont">
                    <div class="txt">游戏币仅限本世界杯足球竞猜活动使用，不做其他用途。</div>
                </div>
            </div>
            
          
        </div>
        

    </div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
export default {
    name :'PullRules',
    props:['status'],
    data(){
        return {}
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:700px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; padding:20px 25px; position: relative; border-radius: 10px; background-size: 100%;
    .title-text{font-size: 20px; line-height: 40px; color: #fff; font-weight: 600; margin-bottom: 10px;}
    .tag{position: absolute; right: 75px; top: 5px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.rule-cont{
    padding: 20px; background: #fff; border-radius: 10px; 
    .rule-item{
        display: flex; font-size: 16px; line-height: 30px; color: #353535;
        .li-ico{padding-top: 3px; margin-right: 3px;}
    }
}
@media screen and (max-width:768px) {
    .ball-cup-container{
        padding: 20px 10px;
    }
    .rule-cont{padding: 10px;}
}
</style>